// Win32 U-symbols: ↑ ↓ 🡅 🡇 🠙 🠛 🠝 🠟 🠉 🠋 🡑 🡓 ⇑ ⇓ ⇧ ⇩ ⮝ ⮟ ⮙ ⮛ 🡱 🡳 / MacOS U-symbols: ↑ ↓ ⬆ ⬇
export const [upArrow, downArrow, pushArrow] = navigator.platform === 'Win32' ? ['🡅', '🡇', '🡳'] : ['⬆', '⬇', '↓'];

export const COLORS = {
    default: '#000',
    error: '#e53935',
    unknownPush: '#887f9b',
    unknownType: '#acacac'
};

export const PARSE_TYPES = {
    gc: 'parseGCMessage',
    pas: 'parsePasMessage',
    info: 'parseInfoMessage',
    http: 'parseHTTPMessage',
    worker: 'parseWorkerMessage',
    azure: 'parseAzureMessage',
    redux: 'parseReduxMessage',
    nesting: 'parseNestingMessage',
    openAPI: 'parseOpenApiMessage',
    redirect: 'parseRedirectMessage'
};

export const LOG_TYPES = {
    // openAPI
    oapiInfo: ['#ee5300', 'log', 'OAPI | Portal', PARSE_TYPES.info],
    oapiError: [COLORS.error, 'error', 'OAPI | Portal ❌', PARSE_TYPES.openAPI],
    oapiNotice: [COLORS.unknownType, 'error', 'OAPI | Portal ❌', PARSE_TYPES.openAPI],
    oapiPush: ['#546e7a', 'log', `OAPI | Portal ${pushArrow}`, PARSE_TYPES.openAPI],
    oapiRequest: ['#1e88e5', 'log', `OAPI | Portal ${upArrow}`, PARSE_TYPES.openAPI],
    oapiResponse: ['#43a047', 'log', `OAPI | Portal ${downArrow}`, PARSE_TYPES.openAPI],
    // HTTP
    httpErr: [COLORS.error, 'error', 'HTTP | Portal ❌', PARSE_TYPES.http],
    httpReq: ['#9c27b0', 'log', `HTTP | Portal ${upArrow}`, PARSE_TYPES.http],
    httpRes: ['#58b897', 'log', `HTTP | Portal ${downArrow}`, PARSE_TYPES.http],
    // Worker
    workerErr: [COLORS.error, 'error', 'Worker | Portal ❌', PARSE_TYPES.worker],
    workerReq: ['#baee00', 'log', `Worker | Portal ${upArrow}`, PARSE_TYPES.worker],
    workerRes: ['#588db8', 'log', `Worker | Portal ${downArrow}`, PARSE_TYPES.worker],
    // GC
    gcErr: [COLORS.error, 'error', 'GC | Portal ❌', PARSE_TYPES.gc],
    gcReq: ['#b0a227', 'log', `GC | Portal ${upArrow}`, PARSE_TYPES.gc],
    gcRes: ['#b87d58', 'log', `GC | Portal ${downArrow}`, PARSE_TYPES.gc],
    gcInfo: ['#c55108', 'log', 'GC | Portal', PARSE_TYPES.gc],
    gcSub: ['#7008c5', 'log', 'GC | Portal ${downArrow}', PARSE_TYPES.gc],
    // PAS
    pasInfo: ['#ee5300', 'log', 'PAS | Portal', PARSE_TYPES.info],
    pasError: [COLORS.error, 'log', 'PAS | Portal ❌', PARSE_TYPES.pas],
    pasSend: ['#9c27b0', 'log', `PAS | Portal ${upArrow}`, PARSE_TYPES.pas],
    pasReceived: ['#58b897', 'log', `PAS | Portal ${downArrow}`, PARSE_TYPES.pas],
    // Redirect
    azureTrackEvent: ['#48a7ee', 'log', 'Azure Tracker | Portal', PARSE_TYPES.redirect],
    redirectRequest: ['#002c9c', 'log', `Redirect | Portal ${upArrow}`, PARSE_TYPES.redirect],
    redirectResponse: ['#004000', 'log', `Redirect | Portal ${downArrow}`, PARSE_TYPES.redirect],
    // File nesting
    redux: ['#FE9246', 'log', 'Redux | Portal', PARSE_TYPES.redux],
    nesting: ['#FE9246', 'log', 'Nesting | Portal', PARSE_TYPES.nesting]
};

export const PUSH_MESSAGES = {
    10: 'Failed to send request',
    300: 'No more connections notification',

    31135: 'Notify Action Closed Notification',
    71031: 'Leader board change summary notification',

    71032: 'Leader board change details notification',
    34001: 'Relogin by server',
    33004: 'Logged out by server',
    32010: 'Notify Balance Change Notification',
    31021: 'Dynamic Balance Notification',
    31010: 'Terms and Conditions Notification',
    31012: 'Change Password Notification',
    33005: 'Bonus Message Accept Notification',
    31026: 'Show Message Notification',
    31133: 'Show Action Notification',
    31009: 'Wrong authentication token',
    31027: 'Login messages from IMS',
    31014: 'Logout'
};
